import React from 'react';
import { Lock, GripVertical } from 'lucide-react';
import ColumnActionsMenu from './ColumnActionsMenu';

const ColumnHeader = ({
  column,
  taskCount,
  firstNonAiColumnName,
  onRename,
  onChangeColor,
  onDelete,
  onDragHandlePointerDown,
}) => {
  const accentColor = column.color || '#9ca3af';
  const isAI = column.is_ai_suggestions;

  const handlePointerDown = (e) => {
    if (isAI || !onDragHandlePointerDown) return;
    e.preventDefault();
    onDragHandlePointerDown(e);
  };

  return (
    <div
      className={`px-3 py-2.5 bg-white border-b border-gray-200 rounded-t-xl flex justify-between items-center group select-none
        ${!isAI ? 'cursor-grab active:cursor-grabbing' : ''}`}
      onPointerDown={handlePointerDown}
    >
      <div className="flex items-center gap-2 min-w-0 pointer-events-none">
        <span
          className="w-2 h-2 rounded-full flex-shrink-0"
          style={{ backgroundColor: accentColor }}
        />
        {isAI && (
          <Lock size={12} className="flex-shrink-0 text-gray-400" />
        )}
        {!isAI && (
          <GripVertical size={13} className="flex-shrink-0 text-gray-300 opacity-0 group-hover:opacity-100 transition-opacity" />
        )}
        <span className="truncate text-sm font-medium text-gray-700">{column.name}</span>
        <span className="text-xs text-gray-400 tabular-nums">{taskCount}</span>
      </div>

      <div
        className="flex items-center gap-0.5 flex-shrink-0 opacity-0 group-hover:opacity-100 transition-opacity"
        onPointerDown={(e) => e.stopPropagation()}
      >
        <ColumnActionsMenu
          column={column}
          firstNonAiColumnName={firstNonAiColumnName}
          onRename={onRename}
          onChangeColor={onChangeColor}
          onDelete={onDelete}
        />
      </div>
    </div>
  );
};

export default ColumnHeader;
